/*!

=========================================================
* Argon Dashboard PRO React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

*/
import React, { useEffect } from 'react';
import {
  useSelector
} from 'react-redux';
import _ from 'lodash';

// react library for routing
import {
  useLocation, Route, Switch, Redirect
} from 'react-router-dom';

// core components
import Sidebar from 'components/Sidebar/Sidebar.js';

import routes from '../routes.js';

// Account config
import config from 'config';
import AdminFooter from '../components/Footers/AdminFooter';
import AdminNavbar from '../components/Navbars/AdminNavbar';
import { useAccountInitializationAdmin, useActiveAccount } from '../hooks/useAccount';
import useProfile from '../hooks/useProfile';

// Import firebase

export default function Admin() {
  const account = useSelector((state) => state.account);

  useAccountInitializationAdmin();

  // Check for initialization
  if (!account.initialized) {
    return (
      <div className="content">
        <div className="text-center">
          <h1>Loading Account...</h1>
        </div>
      </div>
    );
  }

  return (
    <ProfileLoader />
  );
}

function ProfileLoader() {
  const profile = useSelector((state) => state.profile);

  useProfile();

  // Check for initialization
  if (!profile.initialized) {
    return (
      <div className="content">
        <div className="text-center">
          <h1>Loading Profile...</h1>
        </div>
      </div>
    );
  }

  return (
    <PersonaLoader />
  );
}

function PersonaLoader() {
  const account = useSelector((state) => state.account);

  useActiveAccount();

  if (!account.active) {
    return (
      <div className="content">
        <div className="text-center">
          <h1>Loading Active Client...</h1>
        </div>
      </div>
    );
  }

  return (
    <AdminContent />
  );
}

function AdminContent() {
  // States
  const [sidenavOpen, setSidenavOpen] = React.useState(true);
  const location = useLocation();
  const mainContentRef = React.useRef(null);

  // Scroll to top
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContentRef.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routesToMap) => routesToMap.map((prop, key) => {
    if (prop.collapse) {
      return getRoutes(prop.views);
    }

    if (prop.layout === '/admin') {
      return (
        <Route
          path={prop.layout + prop.path}
          component={prop.component}
          key={prop.path}
          exact={prop.exact || false}
        />
      );
    }

    return null;
  });

  // Brand text
  const getBrandText = (path) => {
    for (let i = 0; i < routes.length; i++) {
      if (
        location.pathname.indexOf(routes[i].layout + routes[i].path)
                !== -1
      ) {
        return routes[i].name;
      }
    }
    return 'Brand';
  };

  // toggles collapse between mini sidenav and normal
  const toggleSidenav = (e) => {
    if (document.body.classList.contains('g-sidenav-pinned')) {
      document.body.classList.remove('g-sidenav-pinned');
      document.body.classList.add('g-sidenav-hidden');
    } else {
      document.body.classList.add('g-sidenav-pinned');
      document.body.classList.remove('g-sidenav-hidden');
    }
    setSidenavOpen(!sidenavOpen);
  };

  // Nav theme
  const getNavbarTheme = () => (location.pathname.indexOf('admin/alternative-dashboard') === -1
    ? 'dark'
    : 'light');

  let pageTitle = '';

  // TODO: rework route structure to avoid this
  if (location.pathname === '/admin/customers/acquisition') {
    pageTitle = 'Customer Acquisition';
  }

  return (
    <>
      <Sidebar
        routes={routes}
        toggleSidenav={toggleSidenav}
        sidenavOpen={sidenavOpen}
        logo={{
          innerLink: '/',
          imgSrc: config.assets.img.brand.logo,
          imgAlt: '...'
        }}
      />
      <div className="main-content" ref={mainContentRef}>
        <AdminNavbar
          theme={getNavbarTheme()}
          toggleSidenav={toggleSidenav}
          sidenavOpen={sidenavOpen}
          pageTitle={pageTitle}
        />
        <Switch>
          {getRoutes(routes)}
          <Redirect from="*" to="/admin/home" />
        </Switch>
        <AdminFooter />
      </div>
      {sidenavOpen ? (
        <div className="backdrop d-xl-none" onClick={toggleSidenav} />
      ) : null}
    </>
  );
}
